// @flow

import { observer } from "mobx-react";
import * as React from "react";

import type { WatchTourItem } from "./WatchTourStack";
import WatchTourStack from "./WatchTourStack";

import Overlay from "app/components/Overlay/Overlay";
import TourItem from "app/components/WatchTourItem/TourItem";
import VideoShareStore from "app/stores/VideoShareStore";

import "./WatchTour.scss";

type Props = {
    enabled: boolean,
    children: React.Node
};

type State = {
    item: ?WatchTourItem
};

@observer
export default class WatchTour extends React.Component<Props, State> {
    positioner: ?HTMLDivElement;
    watchTourStack: WatchTourStack = new WatchTourStack();

    render() {
        const classes = ["WatchTour"];

        if (VideoShareStore.sharing) {
            classes.push("WatchTour--blur");
        }

        const item = this.watchTourStack.item;
        if (item) {
            classes.push("WatchTour--active");
            classes.push("WatchTour--" + item.name);
        }

        return (
            <div className={classes.join(" ")}>
                {this.renderTour()}
                <div className="WatchTour__children">{this.props.children}</div>
            </div>
        );
    }

    componentDidMount() {
        setTimeout(() => this.updatePositionerStyle(), 1);

        if (this.props.enabled) {
            this.watchTourStack.start();
        }
    }

    componentDidUpdate() {
        setTimeout(() => this.updatePositionerStyle(), 1);
    }

    updatePositionerStyle = () => {
        const item = this.watchTourStack.item;
        const positioner = this.positioner;
        if (!item || !positioner) return;

        const reference = document.getElementsByClassName(
            item.referenceClass
        )[0];
        const clientRect = reference.getBoundingClientRect();

        let style = {};
        if (item.position === "bottom") {
            style.left = clientRect.left + clientRect.width / 2 + "px";
            style.top = clientRect.bottom + "px";
        } else {
            style.left = clientRect.right + "px";
            style.top = clientRect.top + clientRect.height + "px";
        }

        positioner.setAttribute(
            "style",
            "top: " + style.top + "; left: " + style.left
        );
    };

    renderTour() {
        const item = this.watchTourStack.item;
        if (!item) return null;

        const nextButtonText = this.watchTourStack.hasNext ? "Next" : "Done";

        let text = item.text;
        if (typeof text === "function") text = text();

        return (
            <div className="WatchTour__tour">
                <Overlay />

                <div
                    ref={element => (this.positioner = element)}
                    className="WatchTour__tour-positioner"
                >
                    <TourItem
                        title={item.title}
                        text={text}
                        onNext={this.watchTourStack.moveNext}
                        nextButtonText={nextButtonText}
                        position={item.position}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/WatchTour/WatchTour.js